// extracted by mini-css-extract-plugin
export default {"tableBtn":"Nutrition_tableBtn__t3DRC","disabledBtn":"Nutrition_disabledBtn__65Z+1","image":"Nutrition_image__r6IdW","name":"Nutrition_name__vJuKj","email":"Nutrition_email__gWxxR"};